import * as React from 'react'
import { TechnicalOrder } from '@models/technical-orders'
import { useCreateOrUpdateTechnicalOrderMutation } from '@api/technical-orders'
import { useNotificationHook } from '@hyper/use-notification-hook'

export const useTechnicalOrderPause = ({ technicalOrders }: { technicalOrders: TechnicalOrder[] }) => {
  const [updateTechnicalOrder] = useCreateOrUpdateTechnicalOrderMutation()
  const { addSuccessNotification } = useNotificationHook()

  return React.useCallback(async () => {
    for (const technicalOrder of technicalOrders) {
      await updateTechnicalOrder({
        data: {},
        url: technicalOrder.urls.pause,
      }).unwrap()
    }
    addSuccessNotification('Zadanie zostało zatrzymane')
  }, [technicalOrders, updateTechnicalOrder])
}
